import { mailOutline, lockClosedOutline } from 'ionicons/icons';

import { INPUT_TYPES } from '$gbusiness/enums';
import { validateEmail, requiredValidation } from '$gbusiness/helpers/input';
import InputRowModel from '$gbusiness/models/inputRow';

const LOGIN_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        ...INPUT_TYPES.EMAIL,
        gridSize: 12,
        icon: mailOutline,
        validation: [
          requiredValidation,
          {
            condition: (v) => !validateEmail(v),
            message: 'INVALID_EMAIL',
          },
        ],
      },
      {
        ...INPUT_TYPES.PASSWORD,
        icon: lockClosedOutline,
        enterToSubmit: true,
        gridSize: 12,
        position: undefined,
        validation: [requiredValidation],
      },
    ],
  },
];

export default LOGIN_FORM;
